import React, {useEffect, useRef, useState} from 'react';
import {getRusDateHourString} from "../../../../utils/dateUtils";
import CapItemPopover from "../cap/CapItemPopover";
import useResizeObserver from "../../../../hooks/useResizeObserver";
import Spinner from "../../../common/Spinner";
import SimpleTable from "../../../common/tables/SimpleTable";
import {availableBillingTypesData, getOfferNameWithId} from "../../../../utils/offerUtils";
import InputWithIcon from "../../../common/inputs/InputWithIcon";
import {clearGroupedPromotionLinks, loadGroupedPromotionLinks} from "../../../../actions/managerOfferActions";
import {useDispatch, useSelector} from "react-redux";
import MaterialUIMultiSelect from "../../../common/selects/MaterialUIMultiSelect";
import useThemeChange from "../../../../hooks/useThemeChange";
import {
    LIGHT_THEME,
    PARENT_OFFERS,
    PARTNER_GROUPS,
} from "../../../../utils/constants";
import {loadFiltersData} from "../../../../actions/filterDataActions";
import AdminPartnersFilter from "../../../common/filters/AdminPartnersFilter";
import {isMobileScreen} from "../../../../utils/displayUtils";
import IosCheckbox from "../../../common/checkboxes/IosCheckbox";
import {LinkCopyPopup} from "../../../common/linkCopyPopup/LinkCopyPopup";
import OffersToolsPopover from "./OffersToolsPopover";

export default function OffersToolsTable({}) {
    const dispatch = useDispatch();
    const childRef = useRef();

    let {groupedPromotionLinks, groupedPromotionLinksLoading} = useSelector(state => state.managerOffersReducer);
    const {partnerGroups, parentOffers} = useSelector(state => state.filterDataReducer.filterData);
    const [selectedPartners, setSelectedPartners] = useState([]);
    const [selectedOffers, setSelectedOffers] = useState([]);
    const [displayHashedLinks, setDisplayHashedLinks] = useState(true);

    useEffect(() => {
        dispatch(loadFiltersData([PARTNER_GROUPS, PARENT_OFFERS]));
    }, []);


    const loadTableData = () => {
        if (selectedPartners.length === 0 && selectedOffers.length === null) {
            return;
        }
        const partnerIds = selectedPartners?.flatMap(partner => !partner.isGroup
            ? [partner.id]
            : partnerGroups.find(group => group.partnerTypeId === partner.partnerTypeId)?.options.map(partner => partner.id));
        const offerIds = selectedOffers.flatMap(offer => offer.ids)
        dispatch(loadGroupedPromotionLinks(partnerIds, offerIds));
    }

    const resetTableData = () => {
        setSelectedPartners([]);
        setSelectedOffers([]);
        dispatch(clearGroupedPromotionLinks())
    }

    const tableColumns = () => {
        return [
            {
                name: "Партнёр",
                key: "partnerName",
                getBodyCellValue: item => item?.partnerName,
                headerCellStyle: {minWidth: "200px", maxWidth: "300px"},
                bodyCellStyle: {textAlign: "left", maxWidth: "300px"},
            },
            {
                name: "Оффер",
                key: "offerName",
                getBodyCellValue: item => item ? getOfferNameWithId(item?.parentOfferId, item?.parentOfferName) : "",
                headerCellStyle: {width: "240px", minWidth: "240px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Поток",
                key: "source",
                getBodyCellValue: item => item?.offerLinks?.map(data => <div className='offer-table-cell'>{data?.sourceId | ""}</div>),
                headerCellStyle: {minWidth: "50px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Тип выплаты",
                key: "billingType",
                getBodyCellValue: item => item?.offerLinks?.map(data => <div className='offer-table-cell'>{availableBillingTypesData.find(type => type.type === data?.billingType)?.fullName || ""}</div>),
                headerCellStyle: {minWidth: "50px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Ссылка",
                key: "link",
                getBodyCellValue: item => item?.offerLinks?.map(data => <div key={data.channelId} className='offer-table-cell'>
                    <InputWithIcon value={displayHashedLinks ? data?.hashedLink : data?.link} disabled iconClassName="ti ti-files"
                                   onClickIcon={() => childRef.current.handleClickCopy(displayHashedLinks ? data?.hashedLink : data?.link)}
                                                                                       inputStyle={{minHeight: "10px"}}/></div>),
                headerCellStyle: {minWidth: "500px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left", paddingRight: "15px"},
            },
            {
                name: "Создан",
                key: "creationTime",
                getBodyCellValue: item => item?.offerLinks?.map(data => <div className='offer-table-cell'>
                    {data?.creationTime ? getRusDateHourString(new Date(data.creationTime)) : ""}
                </div>),
                headerCellStyle: {minWidth: "100px", width: "100px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Изменён",
                key: "updateTime",
                getBodyCellValue: item => item?.offerLinks?.map(data => <div className='offer-table-cell'>
                    {data?.updateTime ? getRusDateHourString(new Date(data.updateTime)) : ""}
                </div>),
                headerCellStyle: {minWidth: "100px", width: "100px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "",
                key: "actions",
                getBodyCellValue: (item) =>  <OffersToolsPopover button={<i className="ti ti-pencil td-save" style={{cursor: "pointer", fontSize: "18px"}}
                                                                        title="Заменить оффер"/>} item={item} loadTableData={loadTableData}/>,
                bodyCellStyle: {minWidth: "90px", width: "90px", paddingRight: "15px"},
                headerCellStyle: {minWidth: "90px", textAlign: "right"},
                isSortingDisabled: true,
            },
        ]
    };

    const themeName = useThemeChange();
    const inputStyles = {
        border: themeName === LIGHT_THEME ? "1px solid #ced4da" : "1px solid #000",
        borderRadius: ".25rem",
        fontSize: '12px !important',
        padding: "0 0 0 5px",
    };

    const actionInputStyles = {
        root: {
            padding: "0px",
            minWidth: "250px",
            width: "max-content",
            maxWidth:"330px",
            underlineBorderBottom: '0px solid rgba(0,0,0,0) !important',
            flexGrow: "0"
        },
        input: {
            ...inputStyles,
            backgroundColor: themeName === LIGHT_THEME ? "white" : "#1c1c1e",
            minHeight: "30px",

        },
        placeholder: {
            fontSize: "12px !important",
            padding: "0 0 3px 5px",
        },
        chip: { maxWidth: isMobileScreen() ? null : "250px" },
    };

    const tableActionRow =  [
        {
            key: "partnerName",
            getActionCellValue: () =>
                <AdminPartnersFilter selectedPartners={selectedPartners}
                                     handleChangeFilterData={setSelectedPartners}
                                     inputStyle={actionInputStyles}
                                     label=''/>,
        },
        {
            key: "offerName",
            getActionCellValue: () =>
                <MaterialUIMultiSelect dropdownData={parentOffers}
                                       values={selectedOffers}
                                       displayedFields={["id", "offerName"]}
                                       dataField='id'
                                       label=''
                                       placeholder={'-'}
                                       onSelect={setSelectedOffers}
                                       isSearchable={true}
                                       styles={actionInputStyles}
                />,
        },
        {
            key: "source",
            getActionCellValue: () =><div/>
        },
        {
            key: "billingType",
            getActionCellValue: () =><div/>
        },
        {
            key: "hashedLink",
            getActionCellValue: () =><div style={{textAlign: "left", paddingTop: "15px"}} className='form-group edit-offer'>
                <IosCheckbox label='Хэшированная' labelStyle={{fontSize: '13px'}} isChecked={displayHashedLinks}
                             onClickFunction={() => setDisplayHashedLinks(!displayHashedLinks)}/>
            </div>,
            actionCellStyle: {zIndex: 1}
        },
        {
            key: "creationTime",
            getActionCellValue: () =><div/>
        },
        {
            key: "updateTime",
            getActionCellValue: () =><div/>
        },

        {
            key: "action",
            getActionCellValue: () => <div>
                <i className="ti ti-search td-save" onClick={loadTableData} title='Поиск'/>
                <i className="ti ti-close td-save" onClick={resetTableData} title='Очистить'/>

            </div>
        },
    ];

    const height = useResizeObserver(document.getElementById("scrollable")).height - 5;

    return (
        <div className="responsive-block statistic_table_wrapper" id="fullWidth" onScroll={() =>{}} style={{height: height + "px"}}>
            {groupedPromotionLinksLoading
                ? <Spinner/>
                : <SimpleTable tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext z10"
                               columns={tableColumns()} actionRow={tableActionRow} data={groupedPromotionLinks} bodyRowKey="channelId" />}
            <LinkCopyPopup ref={childRef}/>
        </div>
    )
}